<template>
  <div class="article-exam-detail" ref="articleExamDetail">
    <div class="quizze"
      v-for="(exercise, index) in cloneResults"
      :key="index"
      :index="index"
      ref="article-exam">
      <div class="title">
        <div class="label">
          <span>{{index + 1}}</span>
        </div>
        <span v-if="exercise.userAnswer === null" class="no-data">（未作答）</span>
      </div>
      <div class="article">
        <component
          :is="quizzes[exercise.code]"
          :is-exam="true"
          :auto-play="false"
          :mode="exercise.mode"
          :exercise="exercise"
          :is-done="true"
          :is-show-explain="true"
          :index="index"
          :user-answer="cloneResults[index].userAnswer">
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';

import { Tag } from 'element-ui';
import YDLJ from 'vanthink-components/components/quiz/YDLJ/YDLJ-U.vue';
import utils from '@/services/utils';

export default {
  components: {
    ElTag: Tag,
  },
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    beforeExamId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      quizzes: {
        YDLJ,
      },
      cloneResults: [],
    };
  },
  created() {
    this.cloneResults = utils.clone(this.results);
    if (this.beforeExamId) {
      this.fetchBeforeExam();
    }
  },
  mounted() {
    this.renderHighlight();
  },
  methods: {
    setAnchor(index) {
      const el = this.$refs['article-exam'][index];
      this.$refs.articleExamDetail.scrollTop = el ? el.offsetTop : 0;
    },
    renderHighlight() {
      const [first] = this.results;
      const { highlightWords } = first;
      if (highlightWords && highlightWords.length) {
        const content = document.querySelectorAll('.article-exam-detail .article-wrap .content');
        content.forEach((item) => {
          const textArr = item.innerHTML.split(' ').map((text) => {
            let newText;
            for (let i = 0; i < highlightWords.length; i += 1) {
              const word = highlightWords[i];
              const reg = new RegExp(`\\b${word}\\b`, 'gi');
              newText = text.replace(reg, '<span style="color: #5256e6">$&</span>');
              if (text.length !== newText.length) {
                break;
              }
            }
            return newText;
          });
          item.innerHTML = textArr.join(' ');
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .article-exam-detail {
    height: calc(100% - 55px);
    overflow-y: scroll;
    .title {
      margin-top: 10px;
      /deep/ .speaker {
        margin-left: 5px;
      }
      .label {
        position: relative;
        left: 0;
        display: inline-block;
        width: 50px;
        height: 30px;
        border-radius: 0 14px 14px 0;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        color: #fff;
        background-color: $primary;
      }
      .no-data {
        font-size: 24px;
        vertical-align: middle;
        color: $danger;
      }
    }
    .tag {
      display: flex;
      width: 100%;
      .el-tag {
        box-sizing: border-box;
        padding-left: 4px;
        width: 50%;
        font-size: 18px;
      }
    }
    /deep/ .ydlj-container {
      font-family: STFangsong, NSimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
      border: none;
      .article-wrap {
        padding: 0 20px 0;
        width: 100%;
      }
      .list-wrap {
        width: 50%;
      }
      .parse {
        font-size: 18px;
        .parse-text {
          width: 60px;
        }
        .parse-content {
          width: calc(100% - 60px);
          pre {
            font-family: STFangsong, NSimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
            line-height: 2;
          }
        }
      }
    }
  }
</style>
